import { render, staticRenderFns } from "./GenericArtistList.vue?vue&type=template&id=14fc9fa3&scoped=true"
import script from "./GenericArtistList.vue?vue&type=script&lang=js"
export * from "./GenericArtistList.vue?vue&type=script&lang=js"
import style0 from "./GenericArtistList.vue?vue&type=style&index=0&id=14fc9fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc9fa3",
  null
  
)

export default component.exports